import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=4d6f856c&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6f856c')) {
      api.createRecord('4d6f856c', component.options)
    } else {
      api.reload('4d6f856c', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=4d6f856c&", function () {
      api.rerender('4d6f856c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Config/Settings.vue"
export default component.exports